export const KEY_ACTION_NAME = '~n';
export const ACTION_PROPERTY_PREFIX = 'ce_';
export const EXTENDED_ACTION_PROPERTY_PREFIX = '~ext';

export const KEY_CONFIG_ID = `${EXTENDED_ACTION_PROPERTY_PREFIX}_djs_config_id`;
export const KEY_CONFIG_REVISION = `${EXTENDED_ACTION_PROPERTY_PREFIX}_djs_config_revision`;
export const KEY_EVENT_ID = `${EXTENDED_ACTION_PROPERTY_PREFIX}_djs_event_id`;
export const KEY_PARENT = `${EXTENDED_ACTION_PROPERTY_PREFIX}_parent`;
export const KEY_UUID = `${EXTENDED_ACTION_PROPERTY_PREFIX}_uuid`;

export const OPERATOR_CONTAINS = 'contains';
export const OPERATOR_EMPTY = 'empty';
export const OPERATOR_ENDS = 'ends';
export const OPERATOR_EQ = 'eq';
export const OPERATOR_GT = 'gt';
export const OPERATOR_GTE = 'gte';
export const OPERATOR_IS_FALSE = 'is_false';
export const OPERATOR_IS_TRUE = 'is_true';
export const OPERATOR_LT = 'lt';
export const OPERATOR_LTE = 'lte';
export const OPERATOR_MATCH = 'match';
export const OPERATOR_NEQ = 'neq';
export const OPERATOR_NOTCONTAINS = 'notcontains';
export const OPERATOR_NOTEMPTY = 'notempty';
export const OPERATOR_NOTENDS = 'notends';
export const OPERATOR_NOTMATCH = 'notmatch';
export const OPERATOR_NOTSTARTS = 'notstarts';
export const OPERATOR_REGEXP = 'regexp';
export const OPERATOR_STARTS = 'starts';

export const TARGET_ACTION = 'action';
export const TARGET_DOM = 'dom';
export const TARGET_URL = 'url';
export const TARGET_TRUE = 'true';
export const TARGET_FALSE = 'false';
